module.exports = __webpack_public_path__ + "img/right-vector-arrow.1a5290fa.svg";